import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function GameCard({
  icon: Icon, // Destructure the icon prop and rename it to 'Icon'
  title,
  doubleWin,
  tripleWin,
  prize,
  percentage,
  id, // Add id prop for navigation
  description,
  price,
}) {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <>
      <div
        className='flex items-center gap-4 p-2.5 max-xs:gap-2 border rounded-md hover:bg-blue-50 transition-colors'
        onClick={() => navigate(id ? `/bets/${id}` : '/keypad')}
      >
        <img
          src={Icon}
          alt={title}
          className='rounded-lg w-[82px] h-[82px] max-xs:w-[62px] max-xs:h-[62px]'
        />

        <div className='flex-1'>
          <h3 className='font-semibold text-sm font-poppins mb-1 max-xs:text-xs'>
            {title}
          </h3>

          {price && (
            <p className='text-xs font-medium text-[#1E429A] mb-1 max-xs:text-[10px]'>
              {price}
            </p>
          )}
          <div className='text-xs font-poppins text-[#65758B] max-xs:text-[10px]'>
            <p>Double Win ₱{doubleWin}</p>
            <p>Triple Win ₱{tripleWin}</p>
          </div>
        </div>
        <div
          className='bg-[#1E429A] text-white p-1.5 text-base rounded-lg text-center min-w-[80px] max-xs:w-[70px] text-sm cursor-pointer hover:bg-[#15337A] transition-colors'
          onClick={() => navigate(id ? `/bets/${id}` : '/keypad')}
        >
          <div className='font-bold text-[#FBD115]'>₱{prize}</div>
          {user.roleId !== 9 && (
            <div className='font-normal'>{percentage}%</div>
          )}
        </div>
      </div>
    </>
  );
}
